'use client'

import { formatDateTimeNormal, formatImageURL, formatPrice, getOrderDeliveryLabel, getOrderPaymentLabel } from "@/utils/util"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"
import { Package } from "lucide-react"

export default function OrderCard({ order }: { order: any }) {
  const pathname = usePathname()
  const images: string[] = order.products?.map((p: any) => p.variant?.images?.[0]).filter(Boolean) || []
  const itemCount = order.products?.reduce((acc: number, p: any) => acc + (p.quantity || 1), 0) || 0
  const paymentLabel = getOrderPaymentLabel(order)
  const extra = images.length - 3

  return (
    <a href={navigateUrl(`/order/${order.customId}`, pathname)} className="group flex items-center gap-4 sm:gap-6 py-6 focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground">
      <div className="flex gap-1 shrink-0">
        {images.length > 0 ? images.slice(0, 3).map((img, i) => (
          <div key={i} className={`relative w-12 aspect-3/4 bg-muted overflow-hidden ${i > 0 ? 'hidden sm:block' : ''}`}>
            <img src={formatImageURL(img)} alt="" className="w-full h-full object-cover" />
            {i === 2 && extra > 0 && <span className="absolute inset-0 grid place-items-center bg-foreground/50 text-xs text-background tabular-nums">+{extra}</span>}
          </div>
        )) : (
          <div className="w-12 aspect-3/4 bg-muted grid place-items-center">
            <Package aria-hidden className="size-4 text-muted-foreground" strokeWidth={1.25} />
          </div>
        )}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-0.5">
          <span className="text-sm text-foreground tabular-nums">#{order.customId}</span>
          <span className="text-xs text-muted-foreground tabular-nums">{formatDateTimeNormal(order.createdAt)}</span>
        </div>
        <div className="mt-2 flex flex-wrap items-center gap-x-2 text-[11px] tracking-[0.14em] uppercase">
          <span className="text-foreground">{getOrderDeliveryLabel(order)}</span>
          {paymentLabel && <span className="text-muted-foreground">· {paymentLabel}</span>}
        </div>
        {itemCount > 0 && <div className="mt-1.5 text-xs text-muted-foreground tabular-nums">{itemCount} бараа</div>}
      </div>

      <div className="shrink-0 text-right">
        <div className="text-sm tabular-nums">{formatPrice(order.amount)}</div>
        <div className="mt-2 text-[13px]">
          <span className="pb-0.5 bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-position-[0_100%] bg-size-[0%_1px] group-hover:bg-size-[100%_1px] transition-[background-size] duration-500 ease-out motion-reduce:transition-none">Дэлгэрэнгүй</span>
        </div>
      </div>
    </a>
  )
}
